// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Editing div.editing-body {
    padding: 0.25em;
    position: relative;
    /* titlebar: 2.5em */
    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
    display: flex;
    flex-direction: column;
    height: 100%;
}

#Editing .editing-minimize-maximize {
    margin-left: 1em;
    cursor: pointer;
    padding: 0.25em;
}

#Editing div.editing-body > div.editing-layer-selection,
#Editing div.editing-body > div.editing-feature-selection,
#Editing div.editing-body > div.ButtonBar {
    flex: 0 0 auto;
}

#Editing div.editing-body > div.AttributeForm {
    margin-top: 0.5em;
    padding-top: 0.5em;
    border-top: 1px solid var(--border-color);
    flex: 1 1 auto;
    overflow: hidden;
}

#Editing select.editing-layer-select,
#Editing select.editing-feature-select {
    width: 100%;
}

#Editing select.editing-layer-select:disabled,
#Editing select.editing-feature-select:disabled {
    cursor: not-allowed;
}

#Editing div.editing-drawpick-results {
    border: 1px solid var(--border-color);
    margin-top: -0.25em;
    background-color: var(--list-bg-color);
}

#Editing div.editing-drawpick-results > div {
    padding: 0.25em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

#Editing div.editing-drawpick-results > div:nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

#Editing div.editing-drawpick-results > div:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}
`, "",{"version":3,"sources":["webpack://./../qwc2/plugins/style/Editing.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gFAAgF,EAAE,oDAAoD;IACtI,+FAA+F,EAAE,oDAAoD;IACrJ,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C","sourcesContent":["#Editing div.editing-body {\n    padding: 0.25em;\n    position: relative;\n    /* titlebar: 2.5em */\n    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n#Editing .editing-minimize-maximize {\n    margin-left: 1em;\n    cursor: pointer;\n    padding: 0.25em;\n}\n\n#Editing div.editing-body > div.editing-layer-selection,\n#Editing div.editing-body > div.editing-feature-selection,\n#Editing div.editing-body > div.ButtonBar {\n    flex: 0 0 auto;\n}\n\n#Editing div.editing-body > div.AttributeForm {\n    margin-top: 0.5em;\n    padding-top: 0.5em;\n    border-top: 1px solid var(--border-color);\n    flex: 1 1 auto;\n    overflow: hidden;\n}\n\n#Editing select.editing-layer-select,\n#Editing select.editing-feature-select {\n    width: 100%;\n}\n\n#Editing select.editing-layer-select:disabled,\n#Editing select.editing-feature-select:disabled {\n    cursor: not-allowed;\n}\n\n#Editing div.editing-drawpick-results {\n    border: 1px solid var(--border-color);\n    margin-top: -0.25em;\n    background-color: var(--list-bg-color);\n}\n\n#Editing div.editing-drawpick-results > div {\n    padding: 0.25em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n}\n\n#Editing div.editing-drawpick-results > div:nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\n#Editing div.editing-drawpick-results > div:hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
